<template>
  <div class="uio">
    <div class="sld_catgory clearfix">
      <!-- <div class="shuheiz"></div> -->
      <ul class="sld_cat sld_show">
        <div class="clearfix sld_cat_item" :class="{autoHeight:diqumore}" :key="index">
          <div>
            <p class="sld_gleft" :class="{autoHeight2:diqumore}">地区</p>
            <ul class="sld_gright">
              <li v-for="(itm, idx) in ooo" :key="idx">
                <a @click="attri(itm)">
                  {{ itm.regionName }}
                </a>
              </li>
              <li class="okm" v-if="isnum && !diqumore" @click="chakan">查看更多</li>
            </ul>
          </div>
        </div>
      </ul>
    </div>

    <div class="sld_catgory">
      <ul class="sld_cat sld_show">
        <div class="clearfix sld_cat_item" :key="index">
          <div>
            <p class="sld_gleft">分类</p>
            <ul class="sld_gright">
              <li v-for="(itm, idx) in ttt" :key="idx">
                <a @click="yui(itm)">
                  {{ itm.productSortName }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </ul>
    </div>

    <div class="sld_catgory">
      <ul class="sld_cat sld_show">
        <div class="clearfix sld_cat_item" :key="index">
          <div>
            <p class="sld_gleft">工厂类型</p>
            <ul class="sld_gright">
              <li v-for="(itm, idx) in uuu" :key="idx">
                <a @click="attri2(itm, idx)">
                  {{ itm.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </ul>
    </div>

    <div class="sld_catgory">
      <ul class="sld_cat sld_show">
        <div class="clearfix sld_cat_item" :key="index">
          <div>
            <p class="sld_gleft">工厂特色</p>
            <ul class="sld_gright">
              <li v-for="(itm, idx) in lll" :key="idx">
                <a @click="attri1(itm, idx)">
                  {{ itm.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </ul>
    </div>


      <div class="sld_catgory">
      <ul class="sld_cat sld_show">
        <div class="clearfix sld_cat_item" :key="index">
          <div>
            <p class="sld_gleft">加工方式</p>
            <ul class="sld_gright">
              <li v-for="(itm, idx) in baoliao" :key="idx">
                <a @click="activeTop(itm, idx)">
                  {{ itm.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </ul>
    </div>

      <div class="sld_catgory">
      <ul class="sld_cat sld_show">
        <div class="clearfix sld_cat_item" :key="index">              
          <div>
            <p class="sld_gleft">手工加工</p>
            <ul class="sld_gright">
              <li v-for="(itm, idx) in daigong" :key="idx">
                <a @click="attriTop(itm, idx)">
                  {{ itm.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </ul>
    </div>

    <div class="yhb"></div>

    <div class="sld_catgory">
      <div class="level_nav_item" style="margin-left: 10px">
        <div style="padding-top: 6px">为您找到以下工厂</div>
        <!-- 工厂循环的数组 -->
        <div class="menu_drop" v-for="(item, index) in fenlei" :key="index">
          <div class="trigger label">
            <span class="trigger_name">{{ item }} </span>
            <span>
              <i class="el-icon-close" @click="one_delete(index)"></i>
            </span>
          </div>
        </div>
        <!-- 地区 -->
        <div class="menu_drop" v-for="(item, index) in diqu" :key="index">
          <div class="trigger label">
            <span class="trigger_name">{{ item }} </span>
            <span>
              <i class="el-icon-close" @click="one_delete1(index)"></i>
            </span>
          </div>
        </div>
        <!-- 类型 -->
        <div class="menu_drop" v-for="(item, index) in leixing" :key="index">
          <div class="trigger label">
            <span class="trigger_name">{{ item }} </span>
            <span>
              <i class="el-icon-close" @click="one_delete2(index)"></i>
            </span>
          </div>
        </div>
        <!-- 特色 -->
        <div class="menu_drop" v-for="(item, index) in tese" :key="index">
          <div class="trigger label">
            <span class="trigger_name">{{ item }} </span>
            <span>
              <i class="el-icon-close" @click="one_delete3(index)"></i>
            </span>
          </div>
        </div>     
          <!-- 加工方式 -->
        <div class="menu_drop" v-for="(item, index) in jiagong" :key="index">
          <div class="trigger label">
            <span class="trigger_name">{{ item }} </span>
            <span>
              <i class="el-icon-close" @click="one_delete4(index)"></i>
            </span>
          </div>
        </div>
        <!-- 代工模式 -->
           <div class="menu_drop" v-for="(item, index) in shougong" :key="index">
          <div class="trigger label">
            <span class="trigger_name">{{ item }} </span>
            <span>
              <i class="el-icon-close" @click="one_delete5(index)"></i>
            </span>
          </div>
        </div>
        <div class="ccctop" @click="clear">重置</div>
        <div class="ccctop" @click="submit111">确定</div>
      </div>  
    </div>

    <!-- <div class="yhb"> </div> -->

    <div class="list" style="margin-top: 10px">
      <div class="opop" @click="jin(0)" :class="hhh == 0 ? 'plm' : ''">
        综合排序
      </div>
      <div class="opop" @click="jin(1)" :class="hhh == 1 ? 'plm' : ''">
        回头率最高
      </div>
      <div class="opop" @click="jin(2)" :class="hhh == 2 ? 'plm' : ''">
        意向客户最多
      </div>
    </div>

    <div class="warp" v-for="(item, index) in arrList" :key="index">
      <div class="box">
        <img
          :src="item.factoryLogoUrl"
          class="image1"
          @click="navtop(item)"
          alt=""
        />
        <div class="center" @click="navtop(item)">
          <p>
            {{ item.factoryName }} <i class="el-icon-location-outline"></i>
            {{ item.city }}
          </p>
          <div class="ytop">{{ item.productSortName }}</div>
          <div class="hyu">
            <img class="icon" src="@/assets/goods/no_collection.png" alt="" />
            <div class="bb">{{ item.followNumber }}意向客户</div>
            <div class="bb kl">|</div>
            <div class="bb" style="white-space: nowrap">
              {{ item.returnRateValue }}回头率
            </div>
          </div>
          <div class="hyu">
            <img class="icon" src="@/assets/goods/damuzhi.png" alt="" />

            <div class="bb">做工精细</div>
          </div>
          <div class="hyu1">
            <div class="btn" v-if="item.factoryFeatureValue[0]">{{ item.factoryFeatureValue[0] }}</div>
            <div class="btn" v-if="item.foundryTypeValue[0]">{{ item.foundryTypeValue[0] }}</div>
            <div class="btn" v-if="item.processMethodValue[0]">{{ item.processMethodValue[0] }}</div>
            <div class="btn" v-if="item.factoryTypeValue">{{ item.factoryTypeValue }}</div>
          </div>
        </div>
        <div class="tfoot">
          <div class="hyu">
            <img
              class="icon"
              v-if="item.isFollow == 'false'"
              style="margin-left: 100px"
              @click="shoucang(item)"
              src="@/assets/goods/no_collection.png"
              alt=""
            />
            <img
              class="icon"
              v-if="item.isFollow == 'true'"
              style="margin-left: 100px"
              @click="shoucang(item)"
              src="@/assets/goods/collection.png"
              alt=""
            />
            <div class="bb">收藏</div>
          </div>

          <div class="ttop" @click="top_Details(item)">
            <i class="el-icon-view"></i> 查看详情
          </div>

          <div class="ttop" style="margin-top: 10px">
            <i class="el-icon-headset"></i> 咨询沟通
          </div>
        </div>
      </div>
    </div>
    <div class="heraer_center">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="tatel"
      >
      </el-pagination>
    </div>
  </div>
</template> 

<script>
//调用接口

import { ref, onMounted, getCurrentInstance } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const arrList = ref([]);
    const isShow = ref("1");
    const hhh = ref(0);
    const bnm = ref("");
    const ooo = ref([]);
    const hharr = ref([]); //选中哪项出现哪像
    const ttt = ref([]);
    const isnum = ref("");
    const diqu = ref([]); //地区
    const fenlei = ref([]); //分类
    const leixing = ref([]); //工厂类型
    const tese = ref([]); //工厂特色
    const jiagong=ref([]); //加工方式
    const shougong=ref([]); //手工加工
    const class1 = ref(""); //地区选择，
    const class2 = ref(""); //分类
    const class3 = ref(""); //工厂类型
    const class4 = ref(""); //工厂特色
    const class5 = ref(""); //加工方式
    const class6 =ref(''); //手工加工
    const diqumore = ref(false); //地区更多展示
    const isdiqumore = ref(false); //地区更多展示获取数据中

    const tatel = ref("");
    
    const uuu = ref([
      {
        name: "大型",
      },
      {
        name: "中型",
      },
      {
        name: "小型",
      },
    ]);
    const lll = ref([
      {
        name: "权威验证",
      },
      {
        name: "外贸",
      },
      {
        name: "政府合作",
      },
      {
        name: "500强合作",
      },
    ]);
   
      const baoliao = ref([
      {
        name: "包工包料",
      },
      {
        name: "来样加工",
      },
        {
        name: "来图加工",
      },
      {
        name: "手工加工",
      },
    ]);
     const daigong = ref([
      {
        name: "OBM",
      },
      {
        name: "ODM",
      },
        {
        name: "OEM",
      },
      {
        name: "OMT",
      },
    ]);
    const { proxy } = getCurrentInstance();
    const oneList = () => {
      let obj = {
        pageSize: 10,
        current: 1,
      };
      proxy.$get("/v3/seller/front/store/list", obj).then((res) => {
        tatel.value = res.data.pagination.total;
        arrList.value = res.data.list;
      });
    };

    const navtop = (item) => {
      router.push({
        path: `/store/index`,
        query: {
          vid: item.factoryId,
        },
      });
    };
    const twolist = () => {
      proxy.$get("/v3/system/front/region/getList").then((res) => {
        let arr = res.data;
        if (arr.length > 10) {
          for (let i = 0; i < 10; i++) {
            ooo.value[i] = arr[i];
          }
          //判斷是否出現更多按鈕
          isnum.value = true;
        } else {
          ooo.value = arr;
          isnum.value = false;
        }

        console.log(ooo.value);
      });
    };

    const tresslist = () => {
      let obj = {
        pageSize: 10,
        current: 1,
      };
      proxy.$get("/v3/seller/front/store/productlist", obj).then((res) => {
        let arr = res.data.list;
        console.log(res);
        if (arr.length > 10) {
          for (let i = 0; i < 10; i++) {
            ttt.value[i] = arr[i];
          }
        } else {
          ttt.value = arr;
        }
        //  console.log( ooo.value)
      });
    };
    const top_Details = (item) => {
      router.push({
        path: "/store/gongchang3",
        query: {
          vid: item.factoryId,
        },
      });
    };
    //分页
    const handleCurrentChange = (val) => {
      console.log(val);
      let obj = {
        pageSize: 10,
        current: val,
      };
      proxy.$get("/v3/seller/front/store/list", obj).then((res) => {
        tatel.value = res.data.pagination.total;
        arrList.value = res.data.list;
      });
    };
    const handleSizeChange = (val) => {
      let obj = {
        pageSize: 10,
        current: val,
      };
      proxy.$get("/v3/seller/front/store/list", obj).then((res) => {
        tatel.value = res.data.pagination.total;
        arrList.value = res.data.list;
      });
    };
    // 分类
    const yui = (item1) => {
      fenlei.value[0] = item1.productSortName;
      class2.value = item1.productSortId;
    };
    //地区
    const attri = (item1) => {
      diqu.value[0] = item1.regionName;
      class1.value = item1.regionCode;
    };
    //做成单选这个地方做操作 工厂特色
    const attri1 = (item1, idx) => {
      tese.value[0] = item1.name;
      class4.value = idx + 1;
    };
    //工厂类型
    const attri2 = (item1, idx) => {
      leixing.value[0] = item1.name;
      class3.value = idx + 1;
    };
    //手工加工
    const activeTop=(item1,idx)=>{
       jiagong.value[0] =item1.name;
       class5.value=idx+1;
    };
    //手工加工
    const attriTop=(item1,idx)=>{
       shougong.value[0] =item1.name;
       class6.value=idx+1;
    }
    //确定
    const submit111 = () => {
      let obj1 = {
        pageSize: 10,
        current: 1,
      };
      if (class3.value != "") {
        obj1.factoryType = class3.value;
      }
      if (class4.value != "") {
        obj1.factoryFeature = class4.value;
      }
      if (class2.value != "") {
        obj1.productSortId = class2.value;
      }
      if (class1.value != "") {
        obj1.companyProvinceCode = class1.value;   
      }
      if (class5.value != "") {
        obj1.processMethod = class5.value;   
      }
       if (class6.value != "") {
        obj1.foundryType  = class6.value;   
      }
      proxy.$get("/v3/seller/front/store/list", obj1).then((res) => {
        if (res.state == 200) {
          tatel.value = res.data.pagination.total;
          arrList.value = res.data.list;
        } else {
          ElMessage(res.msg);
        }
      });
    };

    const shoucang = (item) => {
      console.log(item);
      if (item.isFollow === "true") {
        bnm.value = "false";
      } else {
        bnm.value = "true";
      }
      // console.log(bnm.value,11111)
      proxy
        .$post("/v3/member/front/followStore/edit", {
          storeIds: item.factoryId,
          isCollect: bnm.value,
        })
        .then((res) => {
          console.log(res);
          oneList();
        });
    };
    const chakan = () => {
      if(diqumore.value || isdiqumore.value){ return; }
      isdiqumore.value = true;
      proxy.$get("/v3/system/front/region/getList").then((res) => {
        let arr = res.data;
        ooo.value = arr;
        diqumore.value = true;
        isdiqumore.value = false;
      });
    };
    //单个删除
    const one_delete = (index) => {
      console.log(index);
      fenlei.value.splice(index, 1);
      class2.value = "";
    };

    const one_delete1 = (index) => {
      diqu.value.splice(index, 1);
      class1.value = "";
    };
    const one_delete2 = (index) => {
      leixing.value.splice(index, 1);
      class3.value = "";
    };
    const one_delete3 = (index) => {
      tese.value.splice(index, 1);
      class4.value = "";
    };
     const one_delete4 = (index) => {
      jiagong.value.splice(index, 1);
      class5.value = "";
    };
     const one_delete5 = (index) => {
      shougong.value.splice(index, 1);
      class6.value = "";
    };

    //全部清除
    const clear = () => {
      diqu.value = [];
      fenlei.value = [];
      leixing.value = [];
      tese.value = [];
      jiagong.value=[];
      // 全部清除之后把所有的数据给调出来
      // tresslist()
      // twolist();
      oneList();
    };
    // 排序
    const jin = (item) => {
      hhh.value = item;
      proxy.$get("/v3/seller/front/store/list", { sort: item }).then((res) => {
        tatel.value = res.data.pagination.total;
        arrList.value = res.data.list;
      });
    };
    onMounted(() => {
      oneList();
      twolist();
      tresslist();
    });
    return {
      arrList,
      oneList,
      navtop,
      shoucang,
      isShow,
      submit111,
      jin,
      one_delete,
      one_delete1,
      one_delete2,
      one_delete3,
      one_delete4,
      one_delete5,
      hhh,
      twolist,
      bnm,
      ooo,
      clear,
      tresslist,
      ttt,
      uuu,
      tatel,
      lll,
      attri,
      attri1,
      yui,
      activeTop,
      attriTop,
      hharr,
      class1,
      class2,
      class3,
      class4,
      class5,
      class6,
      diqumore,
      isdiqumore,
      isnum,   
      chakan,
      attri2,
      jiagong,
      shougong,

      top_Details,
      diqu,
      fenlei,
      leixing,
      tese,
      handleSizeChange,
      handleCurrentChange,
      daigong,
      baoliao
    };
  },
};
</script>


<style lang="scss" scoped>
.uio {
  width: 100%;
  background-color: #f2f2f2;
}
.list,
.yhb {
  width: 1200px;
  height: 50px;
  overflow: hidden;
  background-color: #fff;
  margin: 0 auto;
  display: flex;
}

.sld_catgory {
  width: 1200px;
  background-color: #fff;
  margin: 0 auto;
  display: flex;
  position: relative;
}

.opop {
  width: 100px;
  height: 40px;
  line-height: 40px;
  margin-top: 5px;
  text-align: center;
}
.warp {
  width: 1200px;
  height: 150px;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 10px;
}
.plm {
  color: red;
}
.box {
  width: 1200px;
  height: 150px;
  display: flex;

  justify-content: space-between;
}
.image1 {
  width: 130px;
  height: 130px;
  margin-top: 10px;
  margin-left: 20px;
  /* background-color:blue; */
  display: block;
}
.center {
  width: 600px;
  height: 130px;
  /* background-color: red; */
  margin-top: 10px;
  font-size: 13px;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.tfoot {
  width: 200px;
  height: 130px;
  /* background-color: #f5f6; */
  margin-top: 10px;
  margin-right: 20px;
}

.hyu {
  width: 500px;
  height: 20px;
  line-height: 50px;
  display: flex;
  margin-top: 10px;
}
.hyu1 {
  width: 500px;
  height: 20px;
  line-height: 50px;
  display: flex;
  margin-top: 2px;
}
.bb {
  width: 70px;
  height: 20px;
  line-height: 20px;
  /* text-align: center; */
}
.kl {
  width: 20px;
  text-align: center;
  color: #ccc;
}
.ytop {
  margin-top: 10px;
}
.btn {
  width: 80px;
  height: 20px;
  line-height: 20px;
  background-color: #ccc;
  border-radius: 3px;
  margin-top: 5px;
  font-size: 12px;
  text-align: center;
  margin-left: 5px;
}
.kon {
  margin-top: 0px;
  margin-left: 154px;
}
.ttop {
  width: 100px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  margin-top: 10px !important;
  border-radius: 3px;
  margin: 0 auto;
  color: red;
  text-align: center;
  border: 1px solid red;
  &:hover {
    background-color: red;
    color: #fff;
  }
}
.yhb {
  height: 15px;
}

.clearfix {
  display: block;
  zoom: 1;

  &:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
}

.sld_cat {
  border: 1px solid #f2f2f2;
  border-bottom: none;
  margin-top: -1px;
  width: 100%;

  .sld_cat_item {
    position: relative;
    border-bottom: 4px solid #f2f2f2;
    padding-right: 150px;
    width: 100%;
    height: 44px;
    overflow: hidden;

    .sld_gleft {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 120px;
      height: 43px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      font-weight: bold;
      border-right: 4px solid #f2f2f2;
    }
    &.autoHeight {
      height: auto;
      .autoHeight2 {
        height: 100%;
      }
    }
    .ttopherp {
      background-color: red !important;
      color: #fff !important;
    }
    .sld_gright {
      float: left;
      margin: 10px 0 10px 144px;
      background-color: #fff;
      position: relative;
    }

    li a {
      color: #666;
      cursor: pointer;

      &:hover {
        color: $colorMain;
      }
    }

    li {
      float: left;
      margin-right: 40px;
      line-height: 23px;
    }
  }

  .sld_cat_item_open:not(:nth-child(1)):not(:nth-child(2)) {
    display: block;
  }

  .sld_cat_item_hide:not(:nth-child(1)):not(:nth-child(2)) {
    display: none;
  }
}

.sld_more_bo {
  position: absolute;
  bottom: -23px;
  left: 50%;
  width: 120px;
  height: 24px;
  line-height: 24px;
  color: #666;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  text-align: center;
  background-color: #fff;
  border: 1px solid #d7d7d7;
  border-top: none;

  i {
    display: inline-block;
    vertical-align: middle;
    font-size: 12px;
    transition: all 0.3s;
  }

  &:hover {
    color: $colorMain;
    text-decoration: none;
  }
}

.sld_more_bo.on {
  i {
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
    transform: rotate(-180deg);
  }
}

.level_nav_item {
  font-size: 12px;
  height: 40px;
  padding: 6px 0 4px;
  position: relative;
  float: left;
  margin-right: 5px;
  display: flex;

  .menu_drop {
    display: inline-block;
    height: 24px;
    margin-left: 20px;
    cursor: pointer;

    .trigger {
      position: relative;
      display: inline-block;
      height: 26px;
      min-width: 89px;
      padding: 0 4px 0 8px;
      border: 1px solid #e1e1e1;
      line-height: 24px;
      vertical-align: top;
      background-color: #fff;
      z-index: 1;

      .trigger_name {
        display: inline-block;
        vertical-align: top;
        color: #848484;
      }
      &.label {
        margin-right: 5px;
        padding-right: 0;
        &:hover {
          border: 1px solid $colorMain;
          span:nth-child(2) {
            background-color: $colorMain;
          }
          .el-icon-close {
            color: #fff;
          }
        }
        span:nth-child(2) {
          margin-left: 5px;
          display: inline-block;
          width: 24px;
          height: 24px;
        }
      }
    }

    .menu_drop_arrow {
      float: right;
      display: inline-block;
      width: 16px;
      height: 16px;
      vertical-align: top;
      background: url(../../assets/search.png) no-repeat 2px 7px;
      -moz-transition: background-position 0.15s ease-in-out;
      transition: background-position 0.15s ease-in-out;
      overflow: hidden;
      margin-top: 2px;
      margin-left: 5px;
    }

    .el-icon-close {
      float: right;
      display: inline-block;
      width: 16px;
      height: 16px;
      vertical-align: top;
      margin-top: 4px;
      margin-right: 3px;
      transition: all 0.2s;
      &:before {
        font-size: 15px;
      }
    }

    &:hover {
      .hasChild {
        height: 27px;
        border-color: $colorMain;
        border-bottom: none;
        z-index: 5;
      }
      .menu_drop_arrow {
        background-position: 2px -43px;
      }
      .menu_drop_main {
        display: block;
        border-color: $colorMain;
        z-index: 1;
      }
    }
    .menu_drop_main {
      position: relative;
      display: none;
      width: 360px;
      padding: 15px 10px;
      position: absolute;
      left: 0;
      top: 27px;
      border: 1px solid #e1e1e1;
      background-color: #fff;
      z-index: 2;
      margin-top: 5px;
      .menu_drop_list li {
        float: left;
        width: 65px;
        height: 24px;
        overflow: hidden;
        line-height: 24px;
        margin-right: 5px;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 0;
        a {
          color: #333;
        }
      }
    }
  }
}
.ccctop {
  padding-top: 6px;
  padding-left: 10px;
  cursor: default;
  &:hover {
    color: red;
  }
}
.okm {
  position: absolute;
  top: 0;
  right: -100px;
  color: red;
  cursor: pointer;
}
.shuheiz {
  height: 110px;
  width: 10px;
  background-color: red;
  position: absolute;
  top: 0;
  left: 20px;
}
.heraer_center {
  width: 100%;
  height: 50px;
  background-color: #fff;
}
</style>